import { render, staticRenderFns } from "./DirectorVms.vue?vue&type=template&id=39f06dd2&"
import script from "./DirectorVms.vue?vue&type=script&lang=js&"
export * from "./DirectorVms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports